
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#C7C7C7"}}),_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#4B62C1"}},[_c('path',{attrs:{"d":"M22.629 13.72h-8.367a.264.264 0 100 .527h8.367a.264.264 0 100-.527zM22.629 15.736h-8.367a.264.264 0 100 .527h8.367a.264.264 0 100-.527zM22.629 17.751h-8.367a.264.264 0 100 .527h8.367a.264.264 0 100-.527z"}}),_c('path',{attrs:{"d":"M23.466 11.414H13.424c-.845 0-1.533.688-1.533 1.533v6.315c0 .846.688 1.534 1.533 1.534h7.039c.075 0 .145.034.192.093l2.273 2.877a.453.453 0 00.51.15.454.454 0 00.309-.434V20.77A1.54 1.54 0 0025 19.262v-6.315c0-.845-.688-1.533-1.534-1.533zm1.007 7.848c0 .548-.446.999-.993 1.006a.264.264 0 00-.26.264v2.753l-2.151-2.723a.767.767 0 00-.606-.294h-7.039a1.007 1.007 0 01-1.006-1.006v-6.315c0-.554.451-1.006 1.006-1.006h10.042c.555 0 1.007.451 1.007 1.006v6.315z"}}),_c('path',{attrs:{"d":"M10.885 15.774a.703.703 0 00-.455.261l-1.812 2.293V16.03a.264.264 0 00-.26-.264.845.845 0 01-.83-.841V9.428c0-.464.377-.842.841-.842h8.742c.464 0 .842.378.842.842v1.017a.264.264 0 00.527 0V9.428a1.37 1.37 0 00-1.369-1.37H8.37A1.37 1.37 0 007 9.429v5.497c0 .656.47 1.21 1.091 1.34v2.333c0 .188.115.348.291.41a.428.428 0 00.482-.14l1.98-2.506a.178.178 0 01.115-.066.264.264 0 00-.074-.522z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(7 7)","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    